import { render, staticRenderFns } from "./sub-business-item.vue?vue&type=template&id=5621d0ce&scoped=true"
import script from "./sub-business-item.vue?vue&type=script&lang=js"
export * from "./sub-business-item.vue?vue&type=script&lang=js"
import style0 from "./sub-business-item.vue?vue&type=style&index=0&id=5621d0ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5621d0ce",
  null
  
)

export default component.exports